import React from 'react';
import LotServiciosBasicosSection from './LotServiciosBasicosSection';
import LotDetailSectionShell, { LotDetailTable } from './LotDetailSectionShell';

/**
 * Servicios e infraestructura disponible en el entorno del lote.
 */
const LotInfraestructuraSection = ({
  waterNetworkDeficitPct = null,
  sewerDeficitPct = null,
  cookingFuelDeficitPct = null,
  blocked = false,
  blockedMessage = 'Iniciá sesión para ver la infraestructura del lote.',
  hideTitle = false,
}) => (
  <LotDetailSectionShell
    title="Infraestructura"
    hideTitle={hideTitle}
    blocked={blocked}
    blockedMessage={blockedMessage}
  >
    <LotDetailTable>
      <LotServiciosBasicosSection
        waterNetworkDeficitPct={waterNetworkDeficitPct}
        sewerDeficitPct={sewerDeficitPct}
        cookingFuelDeficitPct={cookingFuelDeficitPct}
      />
    </LotDetailTable>
  </LotDetailSectionShell>
);

export default LotInfraestructuraSection;
